module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPHBhdGggZD0iTTEwIDZIMTMuMjE5MkMxMy44Njk4IDYgMTQuMzQ3MiA2LjYxMTM5IDE0LjE4OTQgNy4yNDI1NEwxMi42ODk0IDEzLjI0MjVDMTIuNTc4MSAxMy42ODc3IDEyLjE3ODEgMTQgMTEuNzE5MiAxNEgzQzIuNDQ3NzIgMTQgMiAxMy41NTIzIDIgMTNWOEMyIDcuNDQ3NzIgMi40NDc3MiA3IDMgN0g1TDcgMkg5QzkuNTUyMjggMiAxMCAyLjQ0NzcyIDEwIDNWNlpNNiA3SDlWMTNINloiIGZpbGw9IiNGRkQzMjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/appStore/praise_active.svg
// module id = NS1Q
// module chunks = 4